<nf-grid-wrapper *nfLoader="isRuleCodeLoading">
  <nf-grid-wrapper-content>
    <div
      style="
        width: 100%;
        overflow: hidden;
        background-color: rgb(204, 202, 202);
      "
    >
      <pre
        style="
          max-height: 320px;
          width: 100%;
          white-space: break-word;
          overflow: auto;
        "
        >{{ ruleCode }}</pre
      >
    </div></nf-grid-wrapper-content
  ></nf-grid-wrapper
>
